import { AmplitudeExperiments, AmplitudeVariants } from '../AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '../utils/useAmplitudeExperimentBase';

export const useIncreaseBidIncrementsExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.IncreaseBidIncrementsFrom135To235,
        AmplitudeVariants.IncreaseBidIncrementsFrom135To235.Treatment
    );
